import type { WebsiteComponentsTranslationsShape } from '@grammarly/website-components'
import websiteComponentsTranslationsEs from '@lib/i18n/translations/website-components/es.json'
import cmsTranslationsEn from '@lib/i18n/locales/compiled/en.json'
import cmsTranslationsEs from '@lib/i18n/locales/compiled/es.json'
import { Lang } from '@lib/utils/locale'
import { IntlShape } from 'react-intl'

export type TranslationsDictionary = {
  websiteComponents?: WebsiteComponentsTranslationsShape
  cms: IntlShape['messages']
}

function loadWebsiteComponentsTranslations(lang: Lang): WebsiteComponentsTranslationsShape | undefined {
  // P0 implementation, pull from static local file.

  // P1 - Dynamically import the dictionary based on the locale
  /* TODO - how to do type check while using dynamic import?
   *  Should we use dynamic import?
   *  Should we key the keys programmatically instead (bad runtime cost)?
   */
  // TODO - need to test how this handles when it fails/translations are missing
  // const translations = await import(`@lib/i18n/translations/website-components/${locale}.json`)

  switch (lang) {
    case 'es':
      return websiteComponentsTranslationsEs
    default:
      // English
      return undefined
  }
}

function loadCmsTranslations(lang: Lang): IntlShape['messages'] {
  switch (lang) {
    case 'es': {
      return cmsTranslationsEs
    }
    default: {
      return cmsTranslationsEn
    }
  }
}

export function loadTranslations(lang: Lang): TranslationsDictionary {
  return {
    websiteComponents: loadWebsiteComponentsTranslations(lang),
    cms: loadCmsTranslations(lang),
  }
}
